var styleDataHash = '3d12b0bd';  
export const injectCss = (() => {
  var css = `@keyframes jcgf5{0%{opacity:0}}.hQ3vU{animation:jcgf5 1s steps(2) infinite;background:currentColor;display:inline-block;height:1em;margin:0 2px;position:relative;top:2px;vertical-align:baseline;width:1px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "cursor": "hQ3vU",
  "cursor-blink": "jcgf5"
};